function logoutWithRedirect({ path, lang }) {
  window.location.href = `/logout?redirect=${encodeURIComponent(path || window.location.pathname)}&lang=${encodeURIComponent(lang || '')}`;
}

export { logoutWithRedirect };
